export default function contentPageModalController() {
    return {
        isOpen: false, // Initially closed

        // Methods to control the modal
        open() {
            this.isOpen = true;

            // Disable scrolling when modal is open
            document.documentElement.style.overflow = 'hidden';
        },

        close() {
            this.isOpen = false;

            // Re-enable scrolling when modal is closed
            document.documentElement.style.overflow = '';
        },

        init() {
            // Listen for "Content Page" button clicks
            this.$watch('$store.contentPageModal.requestOpen', (value) => {
                if (value) {
                    this.open();
                    // Reset the flag
                    this.$store.contentPageModal.requestOpen = false;
                }
            });
        }
    };
}
